import { Route } from '@angular/router';
import { MainPageComponent } from './pages/main-page/main-page.component';
import { RouteSlug } from '@app/models';
import { endLotteryGuard } from '@app/_guards/end-lottery.guard';

// const ipGuard: CanActivateFn = ():
//   | Observable<boolean | UrlTree>
//   | Promise<boolean | UrlTree>
//   | boolean
//   | UrlTree => {
//   //     return this._ipService.checkIfIpAllowed().pipe(
//   //       catchError(() => {
//   //         this._store.dispatch(
//   //           new Navigate([`/${RouteSlug.SITE_UNDER_CONSTRUCTION}`]),
//   //         );
//   //         return of(false);
//   //       }),
//   //       map(() => true),
//   //     );
//   return true;
// };

export const appRoutes: Route[] = [
  {
    path: '',
    component: MainPageComponent,
  },
  {
    canActivate: [endLotteryGuard],
    path: RouteSlug.SCRATCH_CARD,
    loadComponent: () =>
      import('./pages/scratch-card/scratch-card.component').then(
        ({ ScratchCardComponent }) => ScratchCardComponent,
      ),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/not-found-page/not-found-page.component').then(
        ({ NotFoundPageComponent }) => NotFoundPageComponent,
      ),
  },
];
